define('modules/home/models/following.list.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var FollowingListModel = BaseModel.extend({
        debugName: 'FollowingListModel',
        base : 'user/following',
        useLocalStorage: true,
        onlyUseLocalStorageForFirstPull: true,
    });
    return FollowingListModel;
});


